import React from 'react'

const ProfileIcon = () => {
  return (
    <div class="d-flex align-items-center flex-column mt-5 linedetails_img">
            <div class="w-100 linedetails-userimg">
                <hr />
                <div class="sprint14-userimg" style={{border: 'none', top: '-15px', left: '44%'}}>
                    {/* <img src={getImgSrc(imagePath, isServerUrl)} alt="profile-pic" /> */}
                    <div className='shimmerBG shimmer-icon-md'></div>
                </div>
            </div>

            <h5 className={`mt-4 font-bold shimmerBG shimmer-text-xs w-30`}>
                {/* {
                    nickname && (
                        <>{nickname}</>
                    )
                } */}
            </h5>
           
        </div>
  )
}

export default ProfileIcon